import { create } from 'zustand';

type BizySidePanelView = 'chat' | 'history';

export type BizyPanelTrigger = 'auto' | 'user' | 'keyboard' | 'navbar_restore' | 'navbar_collapse' | (string & {});

export const BIZY_PANEL_DEFAULT_WIDTH = 352;
export const BIZY_PANEL_MIN_WIDTH = 280;
export const BIZY_PANEL_MAX_WIDTH = 560;

interface BizySidePanelStore {
	isOpen: boolean;
	lastTrigger: BizyPanelTrigger | null;
	view: BizySidePanelView;
	width: number;
	isResizing: boolean;
	open: (trigger?: BizyPanelTrigger) => void;
	close: (trigger?: BizyPanelTrigger) => void;
	toggle: (trigger?: BizyPanelTrigger) => void;
	showChat: () => void;
	showHistory: () => void;
	setWidth: (width: number) => void;
	setIsResizing: (isResizing: boolean) => void;
}

export const useBizySidePanelStore = create<BizySidePanelStore>((set) => ({
	isOpen: false,
	lastTrigger: null,
	view: 'chat',
	width: BIZY_PANEL_DEFAULT_WIDTH,
	isResizing: false,
	open: (trigger) => set({ isOpen: true, lastTrigger: trigger ?? 'user' }),
	close: (trigger) => set({ isOpen: false, lastTrigger: trigger ?? 'user' }),
	toggle: (trigger) => set((state) => ({ isOpen: !state.isOpen, lastTrigger: trigger ?? 'user' })),
	showChat: () => set({ view: 'chat' }),
	showHistory: () => set({ view: 'history' }),
	setWidth: (width) => set({ width: Math.max(BIZY_PANEL_MIN_WIDTH, Math.min(BIZY_PANEL_MAX_WIDTH, width)) }),
	setIsResizing: (isResizing) => set({ isResizing }),
}));
